import { render, staticRenderFns } from "./AlarmNoticePage.vue?vue&type=template&id=e18f525c&"
import script from "./AlarmNoticePage.vue?vue&type=script&lang=js&"
export * from "./AlarmNoticePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports